import axios from 'shared/lib/axios'
import config from 'configuration'
import { flashSuccessMessage, flashErrorMessage } from 'redux-flash'
import { UPDATE_RETAILER, REPLACE_RETAILER } from './actionTypes'

export const fetchRetailer = () => (dispatch) =>
  axios.get('/api/Retailer').then(({ data: { data } }) =>
    dispatch({
      type: UPDATE_RETAILER,
      retailer: data,
    })
  )

export const fetchAdminRetailer = (uuid) => async (dispatch) => {
  try {
    const response = await axios.get(`/api/admin/retailers/${uuid}`)

    dispatch({
      type: UPDATE_RETAILER,
      retailer: response.data.data,
    })
  } catch (err) {
    dispatch(flashErrorMessage(`Error in fetching retailer with uuid ${uuid}`))
  }
}

export const replaceRetailer = (data) => (dispatch) => {
  dispatch({
    type: REPLACE_RETAILER,
    retailer: data,
  })
}

export const setRetailer = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_RETAILER,
    retailer: data,
  })
}

export const updateRetailer = (data) => (dispatch) =>
  axios
    .put('/api/Retailer', data, { headers: { 'Content-Type': 'text/plain' } })
    .then(() =>
      dispatch({
        type: UPDATE_RETAILER,
        retailer: data,
      })
    )
    .then(() =>
      dispatch(
        flashSuccessMessage(
          'Changes successfully saved. It may take several minutes for changes to be reflected on live sites.'
        )
      )
    )
    .catch((err) => {
      dispatch(
        flashErrorMessage(
          err.response.data.message || 'Error in updating retailer.'
        )
      )
    })

export const patchRetailer =
  (data, token = '') =>
  (dispatch) =>
    axios
      .patch('api/Retailer', { ...data, token })
      .then((res) => {
        dispatch({
          type: UPDATE_RETAILER,
          retailer: res.data.data,
        })

        return res
      })
      .catch((err) => {
        dispatch(
          flashErrorMessage(
            err.response?.data?.message || 'Error in updating retailer.'
          )
        )

        throw err
      })

export const createRetailer = (values) => async (dispatch) => {
  try {
    const response = await axios.post('/api/Retailer', { ...values })

    return response
  } catch (err) {
    dispatch(
      flashErrorMessage(
        err.response.data.message || 'Error in updating retailer.'
      )
    )
  }
}

export const setRetailerSession = (uuid) =>
  axios.post('/api/auth/users/set-retailer', { retailer_id: uuid })

export const transferWarranty = async (warrantyUuid, payload) => {
  try {
    const response = await axios.post(
      `/api/transfer-warranty/${warrantyUuid}`,
      { ...payload }
    )

    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
      }
    }
  } catch (err) {
    return false
  }
}

export const fetchRetailerPrograms = async (uuid) => {
  try {
    const params = { retailer_id: uuid }
    const res = await axios.get(`${config.api}/api/pricing-engine/programs`, {
      params,
    })

    return res.data.data
  } catch (err) {
    return err.response
  }
}
